define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
    "../properties/MnemonicProperty",
    "../properties/ShortcutProperty",
    "../properties/ActionIdProperty",
    "../properties/ValueProperty",
    "../properties/MinimumProperty",
    "../properties/MaximumProperty",
    "../properties/ErrorTextProperty",
    "../properties/WarningTextProperty",
    "../properties/ValidationStateProperty",
    "MW/toolstrip/hashes/listOfNewWidgets"

],
    function (lang, TypeConstants, TypeProperty, TagProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty, ValueProperty, MinimumProperty, MaximumProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty, listOfNewWidgets) {
        var hash = {};

        hash[TypeConstants.SPINNER] = lang.mixin({}, {
            editable: {
                type: "boolean",
                defaultValue: false,
                notInAction: false,
                required: false
            },
            minorStepSize: {
                type: "number",
                defaultValue: 5,
                notInAction: false,
                required: false
            },
            majorStepSize: {
                type: "number",
                defaultValue: 10,
                notInAction: false,
                required: false
            },
            errorText: {
                type: "string",
                notInAction: false,
                defaultValue: "The value entered is not in range",
                required: false
            }
        }, listOfNewWidgets.indexOf(TypeConstants.SPINNER) === -1 ? {} : {
                format: {
                    type: "string",
                    defaultValue: "",
                    notInAction: true,
                    required: false
                }
            },
            TypeProperty, TagProperty, EnabledProperty, DescriptionProperty,
            DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
            ValueProperty, MinimumProperty, MaximumProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty);

        return hash;
    });

